import moment from "moment";

export const monthStartEndDates = () => {
  const startDate = moment().startOf("month").format("YYYY-MM-DD");
  const endDate = moment().endOf("month").format("YYYY-MM-DD");

  return { startDate, endDate };
};
